package gr.tech.pdfgenerator.navigation

sealed class SitePage(val route: String) {
    data object Home: SitePage(route = "/")

    data object Login: SitePage(route = "/login")

    data object Projects: SitePage(route = "/projects")

    data object Inputs: SitePage(route = "/inputs")

    data object GenerateMSA: SitePage(route = "/msa")
    data object GenerateProposal: SitePage(route = "/lightingproposal")
    data object GenerateTierThree: SitePage(route = "/tierthree")

}